import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  const location = useLocation();

 useEffect(() => {
  console.log('Page path:', location.pathname);
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-WTKHP85FX6', {
      page_path: location.pathname,
    });
  }
}, [location]);

};

export default usePageTracking;
